/* comments-tone.js — GitHub #1: make Ghost's comments follow our light/dark tone toggle.
 *
 * HOW GHOST'S COMMENTS ACTUALLY PICK A COLOUR SCHEME (verified against comments-ui 1.5.168 —
 * the "mode defaults to auto = the reader's OS setting" note in issue #1 is WRONG; `auto`
 * never consults the OS):
 *
 *     if (mode === 'light') return false;
 *     if (mode === 'dark')  return true;
 *     // auto:
 *     const el = document.getElementById('ghost-comments-root');
 *     const c  = getComputedStyle(el.parentElement).getPropertyValue('color');
 *     return contrast([255,255,255], parse(c)) < 5;   // light-ish text => assume dark bg
 *
 * and it re-runs that check from its own MutationObserver:
 *
 *     observer.observe(el.parentElement, {attributes: true, attributeFilter: ['style','class']})
 *
 * So Ghost already supports live re-theming. Two things were missing on our side:
 *   1. `.gh-comments` set no text colour -> Ghost read whatever inherited and guessed wrong.
 *      FIXED IN CSS: `.gh-comments { color: var(--color-text-primary) }` (screen.css).
 *   2. Our tone toggle sets `data-tone` on <html>, which Ghost is NOT watching -> it never
 *      re-checked. FIXED HERE: mirror the tone onto `.gh-comments` as a class, which IS
 *      watched, so Ghost re-reads the (already-correct) computed colour and re-themes live.
 *
 * The class is a DELIBERATE POKE, not a style hook: it exists to mutate the `class` attribute
 * that Ghost watches. It intentionally has no CSS attached. Do not "clean it up".
 *
 * `.gh-comments` is the right element: comments-ui does
 * `scriptTag.parentElement.insertBefore(root, scriptTag)`, and the script tag is in this div,
 * so root.parentElement === .gh-comments — the exact node Ghost reads AND watches.
 *
 * NO INJECTION: this only touches our own markup and feeds Ghost's own designed mechanism.
 * Nothing here can break when Ghost updates the CDN bundle.
 */
(function () {
    'use strict';

    var root = document.documentElement;
    var container = document.querySelector('.gh-comments');

    if (!container) {
        return;
    }

    function sync() {
        // toggle() mutates the `class` attribute, which is what fires Ghost's observer.
        container.classList.toggle('is-tone-dark', root.getAttribute('data-tone') === 'dark');
    }

    // Run once so the class matches the server-rendered tone before comments-ui mounts.
    sync();

    new MutationObserver(sync).observe(root, {
        attributes: true,
        attributeFilter: ['data-tone']
    });
}());
